<template>
  <div>
    <v-navigation-drawer
      permanent=""
      width="400"
      style="z-index: 8"
      color="smoke"
    >
      <div
        class="pa-4 d-flex justify-space-between align-center"
        style="height: 94px"
      >
        <h1>Support</h1>

        <AddTicket />
      </div>
      <v-divider></v-divider>
      <v-list v-if="tickets.length > 0">
        <v-list-item
          class="pa-4"
          v-for="t in tickets"
          :key="t.uid"
          @click="ticket = t"
          :color="ticket && ticket.uid === t.uid ? 'primary' : 'white'"
        >
          <div
            class="d-flex justify-space-between align-center"
            style="width: 100%"
          >
            <div>
              <v-list-item-title>{{ t.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ t.description }}</v-list-item-subtitle>
            </div>
            <div>
              <v-chip
                variant="flat"
                size="small"
                :color="
                  t.status === 'open'
                    ? 'primary'
                    : t.status === 'resolved'
                      ? 'success'
                      : 'error'
                "
                >{{ t.status }}</v-chip
              >
            </div>
          </div>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item>
          <v-list-item-title>No tickets found</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div class="pa-4 d-flex flex-column" v-if="ticket" style="max-width: 800px">
      <div class="d-flex justify-space-between align-center">
        <h1>Support ticket: {{ ticket.title }}</h1>
        <v-btn
          :disabled="ticket.status === 'closed' || ticket.status === 'resolved'"
          variant="outlined"
          @click="
            $store.dispatch('closeTicket', ticket.uid);
            ticket = null;
          "
          >Close ticket</v-btn
        >
      </div>
      <p style="font-size: 10pt">
        Status:
        <v-chip
          size="small"
          variant="flat"
          :color="
            ticket.status === 'open'
              ? 'primary'
              : ticket.status === 'resolved'
                ? 'success'
                : 'error'
          "
          >{{ ticket.status }}</v-chip
        >
      </p>
      <p style="font-size: 10pt" class="mb-6">
        Created at: {{ new Date(ticket.created_at * 1000).toLocaleString() }}
      </p>
      <div>
        <div class="newMessage" v-if="ticket.status === 'open'">
          <v-textarea
            v-model="newMessage"
            placeholder="Add a message to the ticket"
            rows="3"
            flat
            bg-color="smokeDark"
            variant="solo"
            class="floating-text-field text-caption"
            density="comfortable"
            @keydown.enter="sendMessage"
          >
            <template v-slot:append>
              <v-btn @click="sendMessage" color="primary">Send</v-btn>
            </template>
          </v-textarea>
        </div>

        <v-card
          v-for="m in ticket.messages"
          :key="m.uid"
          flat
          :style="{
            borderBottom: '3px solid #272727',
            borderLeft: '1px solid #272727',
            borderTop: '1px solid #272727',
            borderRight: '3px solid #272727',
            borderRadius: '8px',
            marginLeft: m.role === 'user' ? '0' : '80px',
          }"
          :class="m.role === 'user' ? 'bg-smokeDark' : 'bg-white'"
          class="mb-3"
        >
          <v-card-title>
            <div class="d-flex align-center my-2">
              <v-avatar
                size="30"
                color="accent"
                :style="{
                  borderBottom: '2px solid #272727',
                  borderLeft: '1px solid #272727',
                  borderTop: '1px solid #272727',
                  borderRight: '2px solid #272727',
                }"
              >
                <div v-if="m.role === 'user'">
                  <v-img
                    v-if="userProfile && userProfile.avatar"
                    :src="userProfile.avatar"
                    width="30"
                    height="30"
                  ></v-img>
                  <span
                    style="font-weight: 600; font-size: 10pt"
                    v-else-if="userProfile"
                    >{{
                      userProfile.first_name.charAt(0).toUpperCase() +
                      userProfile.last_name.charAt(0).toUpperCase()
                    }}</span
                  >
                </div>
                <div v-else>
                  <v-img
                    :src="require('@/assets/employees/max-employee.png')"
                    width="30"
                    height="30"
                  ></v-img>
                </div>
              </v-avatar>

              <p class="mb-0 ml-2" style="font-size: 10pt; font-weight: 400">
                {{ m.role === "user" ? userProfile.name : "Max (Founder)" }}
              </p>
            </div>

            <v-divider></v-divider>
            <div class="pa-2" style="font-size: 11pt">
              <p>{{ m.content }}</p>
            </div>
          </v-card-title>
        </v-card>
      </div>
      <p
        class="mt-4"
        v-if="
          ticket.status === 'open' &&
          ticket.messages.length > 0 &&
          ticket.messages[0].role != 'assistant'
        "
      >
        <i>We'll get back to you as soon as possible.</i>
      </p>
    </div>
  </div>
</template>

<script>
import AddTicket from "@/components/support/AddTicket.vue";
import { mapState } from "vuex";

export default {
  components: {
    AddTicket,
  },
  computed: {
    ...mapState({
      tickets: (state) => state.support.tickets,
      loading: (state) => state.loading.support,
      userProfile: (state) => state.users.userProfile,
    }),
  },
  data() {
    return {
      ticket: null,
      newMessage: "",
    };
  },
  methods: {
    async sendMessage() {
      if (this.newMessage.trim() === "") return;
      console.log("sendMessage", this.newMessage);
      this.$store.dispatch("sendMessage", {
        uid: this.ticket.uid,
        message: this.newMessage,
      });
      this.newMessage = "";
    },
  },
};
</script>
